import styled from '@emotion/styled';
import { Grid } from '@mui/material';

export const RegistrationPageStyled = {
  Container: styled(Grid) <any>`
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 24px;
    flex-wrap: wrap;
    min-height: 100vh;
  `,
  ContainerSocials: styled(Grid) <any>`
    min-height: inherit;
    display: flex;
    flex-direction: column;
  `,
  ContainerImage: styled.div<any>`
    height: 60%;
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  `,
  Image: styled.img<any>`
    object-fit: contain;
  `,
  // ContainerButtonsSocial: styled.div<any>``,
  Text: styled.p<any>`
    text-align: center;
    font-family: EncodeSans-Medium;
    font-size: 16px;
    margin-bottom: 20px;
  `,
  Separator: styled.div<any>`
    margin-top: 15px;
  `,
  ContainerButton: styled.div<any>`
    display: flex;
    justify-content: center;
    margin-top: 15px;
  `,
};
